import React from 'react';
import P, { InferProps } from 'prop-types';
import TimeMachineDoc from './time-machine-doc';
import TimeMachineCollection from './time-machine-collection';
import { useStringsContext } from '../../../contexts/strings';
import TimeMachineSelect, { TimeMachineSelectPath } from './time-machine-select';
import { useHistory } from 'react-router-dom';
import SceneHeader from '../../common/scene/scene-header';
import ScenePage from '../../common/scene/scene-page';

function TimeMachine(props: InferProps<typeof TimeMachine.propTypes>) {
  const { strings } = useStringsContext();
  const history = useHistory();

  const onSelectedPath = (path: TimeMachineSelectPath) => {
    history.replace(`/time-machine/${path}`);
  };

  let path = props?.match?.params?.path || 'app-configs';
  if (path) {
    path = decodeURIComponent(path);
    if (path[0] === '/') {
      path = path.substr(1);
    }
    path = path.replaceAll('{', '%7B');
    path = path.replaceAll('}', '%7D');
    path = path.replaceAll('"', '%22');
    if (!path.includes('forzasys')) {
      path = path.replaceAll(',', '%2C');
    }
  }

  const pathLength = path.split('/').length;
  const showCollection = !!(path && pathLength % 2 === 1);

  return (
    <ScenePage title={strings.appBar.timeMachine} breadCrumps={[strings.appBar.superAdmin]}>
      <SceneHeader title={strings.appBar.timeMachine}>
        <TimeMachineSelect onSelectedType={onSelectedPath} />
      </SceneHeader>
      {showCollection ? <TimeMachineCollection path={path} /> : <TimeMachineDoc path={path} />}
    </ScenePage>
  );
}

TimeMachine.propTypes = {
  match: P.shape({
    params: P.shape({
      path: P.string,
    }),
  }),
};

export default TimeMachine;
